export const format = (ts) => {
  const date = new Date(ts)
  return date.toLocaleString()
}
